import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const CountryCode = iotsUtils.fromList(constants.country.countryCodes);
